import axios from "axios";

import baseDomain, { editFaqTagApi } from "../../Constants/apiRoutes";

export const editFaqTag = (data, tagID) => {
  return axios.put(`${baseDomain}${editFaqTagApi}/${tagID}`, data);
};
